<template>
    <div class="image-gallery__small">
        <button
            class="btn-gallery figure figure--small"
            v-for="(item, index) in data"
            :key="`item-${index}`"
            @click="handleClick(item.ImageUrl, index + 1)">
            <img :src="item.ImageUrl" :alt="item.AlternativeText" loading="lazy" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { IGalleryItem } from '../model';
defineProps<{
    data: IGalleryItem[];
}>();

const emit = defineEmits<{
    (e: 'onImageClick', image: string, index: number): void;
}>();

function handleClick(image: string, index: number) {
    emit('onImageClick', image, index);
}
</script>
